"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../../../hooks");
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var Dropdown_1 = __importDefault(require("../../inputs/Dropdown"));
var mapToOptions = ramda_1.pipe(ramda_1.defaultTo([]), ramda_1.map(function (item) { return ({ value: item.id, label: item.popis }); }));
var ObecDropdown = function (_a) {
    var onChange = _a.onChange, value = _a.value, soudniKraj = _a.soudniKraj, soudniOkres = _a.soudniOkres, defaultOption = _a.defaultOption, enableReset = _a.enableReset, handleGetObce = _a.handleGetObce, inputId = _a.inputId;
    var ciselnikyUrl = ConfigProvider_1.useConfig().ciselnikyUrl;
    var getJSON = hooks_1.useGetJSON(ciselnikyUrl + "/SoudniObec", true);
    var loadOptions = function (search) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response, uniqueObec_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!search) return [3 /*break*/, 2];
                    params = {
                        keyword: search,
                        okres: soudniOkres,
                        kraj: soudniKraj,
                    };
                    return [4 /*yield*/, getJSON(params)];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        uniqueObec_1 = [];
                        response.value.forEach(function (element) {
                            var findItem = uniqueObec_1.find(function (x) { return x.kod === element.kod && x.idSoudniOkres === element.idSoudniOkres && x.mestoCastKod === element.mestoCastKod; });
                            if (!findItem)
                                uniqueObec_1.push(element);
                        });
                        if (handleGetObce) {
                            handleGetObce(uniqueObec_1);
                        }
                        return [2 /*return*/, mapToOptions(uniqueObec_1)];
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.option) ? [defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.option] : []];
            }
        });
    }); };
    return (react_1.default.createElement(Dropdown_1.default, { placeholder: "Napi\u0161te n\u00E1zev obce", isSearchable: true, name: "obec", value: value, onChange: onChange, loadOptions: loadOptions, defaultOption: defaultOption, enableReset: enableReset, inputId: inputId }));
};
ObecDropdown.defaultProps = {
    value: undefined,
    soudniOkres: undefined,
    soudniKraj: undefined,
    defaultOption: undefined,
    enableReset: false,
    handleGetObce: undefined,
    inputId: undefined,
};
exports.default = ObecDropdown;
